<template>
    <v-card v-if="!showIFrame">
        <v-card-title>
            {{$t('event.features')}}
            <v-spacer></v-spacer>
            <v-menu v-model="addFeatureMenuOpened"
                    :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" v-on="on">
                        {{$t('add')}}
                        <v-icon right>mdi-plus</v-icon>
                    </v-btn>
                </template>

                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-select outlined
                                          clearable
                                          :label="$t('home_feature.feature')"
                                          :placeholder="$t('home_feature.feature')"
                                          :items="missingFeatureOptions"
                                          v-model="addingFeatureId"></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text
                               @click="addFeature">
                            {{$t('add')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-menu>

        </v-card-title>

        <v-data-table :headers="headers"
                      :items="existingFeatures"
                      :loading="isExistingFeaturePending"
                      disable-sort>
            <template v-slot:item.actions="{item}">
                <v-btn color="red" dark class="ml-3"
                       @click="deleteFeature(item)">
                    {{$t('delete')}}
                    <v-icon right>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
    <v-card v-else outlined>
        <iframe :src="paslaIframeSrc" width="100%" height="800" frameborder="0" allowfullscreen></iframe>
    </v-card>
</template>

<script>
    import {computed, ref} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";

    export default {
        name: 'EventFeatureList',
        setup(props, {root}) {
            const paslaIframeId = process.env.NODE_ENV === 'production' ? ref(['a0711058-fc9a-4bd2-9a22-4886810ab3bb']) : ref(['e96ab950-e3d6-4b52-917d-3fcc00614735']);
            const paslaIframeSrc = process.env.NODE_ENV === 'production' ? 'https://ff.eventionapp.com/pasla2025_login/live_control?token=69719d8f3ac82eee53e71efd7adae2b1' : 'https://uat.eventionapp.com/pasla2025_login/live_control?token=69719d8f3ac82eee53e71efd7adae2b1';

            const {EventFeature, Feature} = root.$FeathersVuex.api;

            const eventId = computed(() => root.$route.params.eventId);
            const showIFrame = computed(() => paslaIframeId.value.includes(eventId.value));

            const addFeatureMenuOpened = ref(false);

            // EventFeature
            const eventFeatureParams = computed(() => {
                return {
                    query: {
                        eventId: eventId.value,
                    }
                }
            });
            const {items: eventFeatures, isPending: isEventFeaturePending} = useFind({
                model: EventFeature,
                params: eventFeatureParams,
            });
            const existingEventFeatureIds = computed(() => eventFeatures.value.map(ef => ef.featureId));

            // Features
            const existingFeatureParams = computed(() => {
                return {
                    query: {
                        id: {
                            $in: existingEventFeatureIds.value,
                        }
                    }
                }
            });
            const {items: existingFeatures, isPending: isExistingFeaturePending} = useFind({
                model: Feature,
                params: existingFeatureParams,
            });

            const missingFeatureParams = computed(() => {
                return {
                    query: {
                        id: {
                            $nin: existingEventFeatureIds.value,
                        }
                    }
                }
            });
            const {items: missingFeatures, isPending: isMissingFeaturePending} = useFind({
                model: Feature,
                params: missingFeatureParams,
            });
            const missingFeatureOptions = computed(() => {
                return missingFeatures.value.map(f => {
                    return {text: f.name, value: f.id}
                });
            });
            const addingFeatureId = ref(null);
            const addFeature = function () {
                new EventFeature({eventId: eventId.value, featureId: addingFeatureId.value}).save().then(() => {
                    root.$store.dispatch('showSnackBar', root.$t('event_feature.save_successful'));
                    addFeatureMenuOpened.value = false;
                });
            };

            // Data Table
            const headers = ref([
                {text: root.$t('event_feature.name'), value: 'name'},
                {text: '', value: 'actions', filterable: false, width: '120', align: 'end'},
            ]);

            // Add / Edit Feature
            const deleteFeature = function (feature) {
                if (confirm(root.$t('event_feature.confirm_delete'))) {
                    const eventFeature = EventFeature.findInStore({
                        query: {
                            eventId: eventId.value,
                            featureId: feature.id,
                        }
                    });
                    eventFeature.data.forEach((ef) => {
                        ef.remove()
                    })
                }
            };


            return {
                paslaIframeId,
                paslaIframeSrc,
                showIFrame,

                addFeatureMenuOpened,
                eventFeatures,
                existingEventFeatureIds,
                isEventFeaturePending,

                headers,
                existingFeatures,
                isExistingFeaturePending,

                missingFeatures,
                isMissingFeaturePending,
                missingFeatureOptions,
                addingFeatureId,
                addFeature,
                deleteFeature,

                DateTime,
                getFileUrl: root.$getFileURL,
            }
        }
    }
</script>
